import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { IPivotProps, IPivotStyleProps, IPivotStyles } from '/druid/Pivot.types';
import { PivotBase } from '/druid/Pivot.base';
import { getStyles } from '/druid/Pivot.styles';

/**
 * The Pivot control and related tabs pattern are used for navigating frequently accessed,
 * distinct content categories. Pivots allow for navigation between two or more content
 * views and relies on text headers to articulate the different sections of content.
 */
export const Pivot: React.FunctionComponent<IPivotProps> = styled<IPivotProps, IPivotStyleProps, IPivotStyles>(
  PivotBase,
  getStyles,
  undefined,
  {
    scope: 'Pivot',
  },
);
